export default function KagoshimaLocationSection() {
  const handleNavigation = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  return (
    <section id="kagoshima" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <h2 className="text-3xl md:text-4xl font-bold text-[#76B947] inline-block border-b-[3px] border-[#76B947] pb-1">
              IDS鹿児島教習所
            </h2>
            <span className="px-4 py-1 bg-[#76B947] text-white text-sm font-bold rounded-full whitespace-nowrap">
              鹿児島拠点
            </span>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Left: Location Information */}
          <div className="space-y-4">
            {/* Card 1: Company */}
            <div className="bg-white border-2 border-gray-100 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                <i className="ri-building-line text-[#76B947] text-xl mr-2 w-6 h-6 flex items-center justify-center"></i>
                運営会社
              </h3>
              <p className="text-gray-700 text-lg">株式会社エコナーセリー</p>
            </div>

            {/* Card 2: Address */}
            <div className="bg-white border-2 border-gray-100 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                <i className="ri-map-pin-line text-[#76B947] text-xl mr-2 w-6 h-6 flex items-center justify-center"></i>
                所在地
              </h3>
              <p className="text-gray-700 mb-3">
                〒899-2504<br />
                鹿児島県日置市伊集院町古城795
              </p>
              <a
                href="https://maps.app.goo.gl/BPji2cEziDuNahKy8"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-[#76B947] hover:text-[#5a8a35] font-semibold cursor-pointer"
              >
                <i className="ri-map-pin-fill text-lg mr-1 w-5 h-5 flex items-center justify-center"></i>
                Google Mapで開く
              </a>
            </div>

            {/* Card 3: Contact */}
            <div className="bg-white border-2 border-gray-100 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                <i className="ri-phone-line text-[#76B947] text-xl mr-2 w-6 h-6 flex items-center justify-center"></i>
                お問い合わせ
              </h3>
              <a
                href="tel:099-213-9466"
                className="text-2xl font-bold text-[#76B947] hover:text-[#5a8a35] mb-2 block cursor-pointer"
              >
                📞 099-213-9466
              </a>
              <p className="text-gray-600">受付時間: 平日 9:00〜17:00</p>
            </div>

            {/* Card 4: Access */}
            <div className="bg-white border-2 border-gray-100 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-roadster-line text-[#76B947] text-xl mr-2 w-6 h-6 flex items-center justify-center"></i>
                アクセス
              </h3>
              <div className="space-y-4">
                <div>
                  <p className="font-semibold text-gray-900 mb-2">🚗 お車でお越しの場合</p>
                  <ul className="text-gray-700 space-y-1 ml-6">
                    <li>• 九州自動車道「薩摩吉田IC」より約10分（約6km）</li>
                    <li>• 鹿児島市中心部より約25分（約18km）</li>
                  </ul>
                </div>
                <div>
                  <p className="font-semibold text-gray-900 mb-2">🚃 公共交通機関をご利用の場合</p>
                  <ul className="text-gray-700 space-y-1 ml-6">
                    <li>• JR「伊集院駅」よりタクシーで約8分（約4km）</li>
                    <li>• ※駐車場完備（無料）</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Card 5: Features */}
            <div className="bg-white border-2 border-gray-100 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-star-line text-[#76B947] text-xl mr-2 w-6 h-6 flex items-center justify-center"></i>
                特徴・サービス
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-[#76B947] mr-2">✅</span>
                  <span>農業ドローン協議会認定スクール</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#76B947] mr-2">✅</span>
                  <span>鹿児島県内のスマート農業を強力サポート</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#76B947] mr-2">✅</span>
                  <span>DJI・FJD製品の販売・サポート</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#76B947] mr-2">✅</span>
                  <span>請負散布業サービス</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Right: Google Map */}
          <div className="lg:sticky lg:top-24 h-fit">
            {/* Location Photo */}
            <div className="mb-5 rounded-xl overflow-hidden shadow-lg h-[300px]">
              <img
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/1630ede3683cd7abed4021d9400d4eb6.webp"
                alt="IDS鹿児島教習所 外観"
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
              />
            </div>

            <div className="rounded-xl shadow-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3450.541847652134!2d130.39442037621547!3d31.602234074160433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x353e694f4533899b%3A0xe423c521a882e187!2zSURT6bm_5YWQ5bO25pWZ57-S5omA!5e0!3m2!1sja!2sjp!4v1733235100000!5m2!1sja!2sjp"
                width="100%"
                height="500"
                style={{ border: 0, borderRadius: '12px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="IDS鹿児島教習所の地図"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
